import React, { useEffect, useState, useCallback, useRef } from 'react';
import Container from '../../Container/Container';
import { useNavigate, useLocation } from 'react-router';
import { useForm, Controller } from "react-hook-form";
import { get, post, postFormData } from '../../ApiServices/ApiServices';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { addDays } from "date-fns";
import { FaCalendarAlt } from "react-icons/fa";
import { useDispatch } from 'react-redux';
import { updateAddress } from '../../redux/profileSlice';

function WeddingEvent({ onNext, ticket, initialValues }) {
    const { register, handleSubmit, setValue, control: mainControl, reset, watch, formState: { errors } } = useForm({
        defaultValues: initialValues

    });

    const { register: registerShipping, handleSubmit: handleSubmitShipping, control, formState: { errors: shippingErrors }, reset: resetShipping } = useForm({
        defaultValues: {
            name: initialValues?.dropShipping?.name || "",
            addressLine1: initialValues?.dropShipping?.addressLine1 || "",
            addressLine2: initialValues?.dropShipping?.addressLine2 || "",
            city: initialValues?.dropShipping?.city || "",
            phone: initialValues?.dropShipping?.phone || "",
            state: initialValues?.dropShipping?.state || "",
            zipCode: initialValues?.dropShipping?.zipCode || "",
        }

    });
    const [dropShippingData, setDropShippingData] = useState(initialValues?.dropShipping || null);
    useEffect(() => {
        setDropShippingData(initialValues?.dropShipping || null)
    }, [initialValues?.dropShipping])
    // console.log(initialValues?.dropShipping, "initialValues?.dropShipping?]]]]]]");
    const location = useLocation()
    const selectedOrderType = watch("order_type");


    useEffect(() => {
        if (initialValues?.dropShipping) {
            resetShipping({
                name: initialValues?.dropShipping?.name || "",
                addressLine1: initialValues?.dropShipping?.addressLine1 || "",
                addressLine2: initialValues?.dropShipping?.addressLine2 || "",
                city: initialValues?.dropShipping?.city || "",
                phone: initialValues?.dropShipping?.phone || "",
                state: initialValues?.dropShipping?.state || "",
                zipCode: initialValues?.dropShipping?.zipCode || "",
                // ... other fields
            });
        }
    }, [initialValues, resetShipping]);

    console.log(initialValues?.dropShipping, "all datatatatat ----- ===== ------ ======");
    const [isDropShipping, setIsDropShipping] = useState(initialValues?.dropShippingswitch || false);
    const editButtonRef = useRef(null);

    useEffect(() => {
        if (initialValues?.dropShippingswitch !== undefined) {
            setIsDropShipping(initialValues.dropShippingswitch);
            if (initialValues?.dropShippingswitch == true) {
                setIsDropShipping(true)
            }
        }
    }, [initialValues?.dropShippingswitch]); // Sync when `initialValues` updates

    const [isChecked, setIsChecked] = useState(false);

    console.log(isDropShipping, "console.log");
    useEffect(() => {
        if (initialValues?.AlternatePickup !== undefined) {
            setIsChecked(initialValues.AlternatePickup);
        }

    }, [initialValues?.AlternatePickup]);
    const [order, setorder] = useState([])
    const [address, setaddress] = useState('')
    // Handler for checkbox change
    const [selectedAddress, setSelectedAddress] = useState('');
    const [openToDate, setOpenToDate] = useState(null); // ✅ Define state for openToDate
    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [getState, setGetState] = useState([]);
    const [selectedCompany, setError] = useState("");


    // console.log(initialValues?.dropShippingswitch
    //     , "initialValues dropShippingswitch")
    console.log(initialValues, "initialValues-------------");

    useEffect(() => {
        if (selectedAddress) {
            const formattedAddress = selectedAddress.split("- Account:")[0];
            dispatch(updateAddress(formattedAddress));
        }
    }, [selectedAddress])

    useEffect(() => {
        ViewState();
        // Re-initialize the form with initial values
        reset(initialValues);
        if (initialValues?.dropShipping?.enabled) {
            setIsDropShipping(true);
            setDropShippingData(initialValues.dropShipping);
            resetShipping(initialValues.dropShipping);
        }
    }, [initialValues, reset, resetShipping]);

    // Add a separate useEffect that runs when order data changes
    useEffect(() => {
        // Only proceed if we have order data and the Affiliated_store is set
        if (order.length > 0 && isChecked && initialValues?.Affiliated_store) {
            const affiliatedStoreName = initialValues.Affiliated_store;
            const selectedCompanyData = order.find(data => data.companyName === affiliatedStoreName);

            if (selectedCompanyData) {
                const companyId = selectedCompanyData.id;
                // ✅ Ensure the dropdown is autofilled
                setValue("Affiliated_store", affiliatedStoreName);
                setValue('store_id', companyId);

                const fetchAffiliatedStoreData = async () => {
                    try {
                        const api = `all-group-customers/${companyId}`;
                        const response = await get(api);
                        if (response?.status === true) {
                            setaddress(response.data);
                        }
                    } catch (err) {
                        console.error('Error:', err);
                    }

                    // Extract Address and Store in State
                    const address = selectedCompanyData?.addresses?.[0];
                    if (address) {
                        setSelectedAddress(
                            `${address.billingAddress || ''}, ${address.billingAddressLine2 || ''}, ${address.billingCity || ''} 
                             ${address.billingState || ''}, ${address.billingZip || ''} - Account: ${selectedCompanyData.account || 'N/A'}`
                        );
                    } else {
                        setSelectedAddress("No Address Available - Account: ${selectedCompanyData.account || 'N/A'}");
                    }
                };

                fetchAffiliatedStoreData();
            }
        }
    }, [order, isChecked, initialValues, setValue]);

    const onDropShippingSubmit = (data) => {
        setDropShippingData(data);
        setIsDropShipping(true);
        document.querySelector('[data-bs-dismiss="modal"]').click();
    };
    const onSubmit = (data) => {
        // Validate that if Alternate Pickup is checked, an affiliated store must be selected
        if (data.AlternatePickup && !data.Affiliated_store) {
            // Show error for the affiliated store field
            setError("Affiliated_store", {
                type: "manual",
                message: "Please select an affiliated store"
            });
            return; // Prevent form submission
        }

        const mergedData = {
            ...data,
            dropShipping: isDropShipping ? {
                enabled: true,
                ...dropShippingData
            } : {
                enabled: false,
                name: "",
                addressLine1: "",
                addressLine2: "",
                city: "",
                state: "",
                zipCode: "",
                phone: ""
            }
        };
        onNext(mergedData);
    };


    const handleCheckboxChange = (e) => {
        setIsChecked(!isChecked);
        // console.log(e.target.checked, "e.target.checked")
        if (e.target.checked) {
            setValue('AlternatePickup', true);
            setValue('dropShippingswitch', false);
            // Set AlternatePickup to true if isChecked is true
        } else {
            setValue('AlternatePickup', false); // Set AlternatePickup to false if isChecked is false
            setValue('Affiliated_store', "")
        }
        if (e.target.checked) {
            setIsDropShipping(false);
            // resetShipping({
            //     name: "",
            //     addressLine1: "",
            //     addressLine2: "",
            //     city: "",
            //     state: "",
            //     zipCode: "",
            //     phone: ""
            // });
        }
    };


    const handleDropShippingToggle = (e) => {
        if (!e.target.checked) {
        } else {
            setValue('AlternatePickup', false); // Set AlternatePickup to false if isChecked is false
            setValue('Affiliated_store', "")
        }


        if (e.target.checked) {
            setValue('dropShippingswitch', true);
            setIsDropShipping(true);

            // Set AlternatePickup to true if isChecked is true
        } else {
            setValue('dropShippingswitch', false); // Set AlternatePickup to false if isChecked is false
            setIsDropShipping(false);

        }


        if (!e.target.checked) {
            setIsDropShipping(false);
            // setDropShippingData(null);
            // resetShipping({
            //     name: "",
            //     addressLine1: "",
            //     addressLine2: "",
            //     city: "",
            //     state: "",
            //     zipCode: "",
            //     phone: ""
            // });
        } else {
            if (!dropShippingData) {
                const modal = document.querySelector('#dropShipping');
                if (modal) {
                    // new bootstrap.Modal(modal).show();
                }
            }
            setIsDropShipping(true);
            setIsChecked(false)
        }
    };




    const ViewState = async () => {
        try {
            const api = `get-states`;
            const response = await get(api);
            if (response?.message === "success") {
                setGetState(response.data);
            }
        } catch (err) {
            console.error('Error:', err);
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        }
    };

    const affilatedorder = async () => {
        try {
            const api = `all-group-customers `;
            const response = await get(api);

            if (response?.status == true) {
                setorder(response?.data?.rows);
            }
        } catch (err) {
            console.error('Error:', err);
        }
    };
    useEffect(() => {
        affilatedorder()
    }, [])

    const formatPhoneNumber = (input) => {
        const cleaned = input.replace(/\D/g, '');
        if (cleaned.length === 0) return '';
        if (cleaned.length <= 3) return `(${cleaned}`;
        if (cleaned.length <= 6) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    };

    const handleChange = (e) => {
        const formatted = formatPhoneNumber(e.target.value);
        if (formatted.length <= 14) {
            e.target.value = formatted;
        }
    };

    const formatPhoneNumbermo = (input) => {
        const cleaned = input.replace(/\D/g, '');
        if (cleaned.length === 0) return '';
        if (cleaned.length <= 3) return `(${cleaned}`;
        if (cleaned.length <= 6) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    };
    const handleChangemo = (e) => {
        const formatted = formatPhoneNumbermo(e.target.value);
        if (formatted.length <= 14) {
            e.target.value = formatted;
        }
    };



    const handleSelectChange = async (event) => {
        const selectedCompanyName = event.target.value;
        if (selectedCompanyName === "") {
            setaddress('');
            setSelectedAddress('');
        } else {
            const selectedCompanyData = order.find(data => data.companyName === selectedCompanyName);

            if (selectedCompanyData) {
                const companyId = selectedCompanyData.id;
                setValue('store_id', companyId)
                // try {
                //     const api = `all-group-customers/${companyId}`;
                //     const response = await get(api);
                //     if (response?.status === true) {
                //         setaddress(response.data);
                //     }
                // } catch (err) {
                //     console.error('Error:', err);
                // }

                // Extract Address and Store in State
                const address = selectedCompanyData?.addresses?.[0];
                if (address) {
                    setSelectedAddress(
                        `${address.billingAddress || ''}, ${address.billingAddressLine2 || ''} ${address.billingAddressLine2 && ','} ${address.billingCity || ''},
                             ${address.billingState || ''}, ${address.billingZip || ''} - Account: ${selectedCompanyData.account || 'N/A'}`
                    );
                } else {
                    setSelectedAddress("No Address Available - Account: ${selectedCompanyData.account || 'N/A'}");
                }
            }
        }
    };

    // Get today's date
    const [selectedDate, setSelectedDate] = useState(null);
    const [minDate, setMinDate] = useState(null);
    const [blockedDates, setBlockedDates] = useState([]);



    useEffect(() => {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Normalize time to avoid mismatch issues
        const dayOfWeek = today.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
        let blockedDatesArray = [];

        if (dayOfWeek >= 0 && dayOfWeek <= 3) { // Sunday(0) through Wednesday(3)
            // Calculate days until next week's Tuesday
            // If today is Sunday(0), next Tuesday is in 2 days
            // If today is Monday(1), next Tuesday is in 8 days
            // If today is Tuesday(2), next Tuesday is in 7 days
            // If today is Wednesday(3), next Tuesday is in 6 days
            const daysUntilNextTuesday = dayOfWeek === 0 ? 2 : (9 - dayOfWeek);

            // Block from today until next Tuesday (inclusive)
            for (let i = 0; i <= daysUntilNextTuesday; i++) {
                const blockedDate = new Date(today);
                blockedDate.setDate(today.getDate() + i);
                blockedDatesArray.push(blockedDate.getTime());
            }
        } else if (dayOfWeek >= 4 && dayOfWeek <= 6) { // Thursday(4) through Saturday(6)
            // Calculate days until 2nd week's Tuesday
            // If today is Thursday(4), 2nd Tuesday is in 12 days
            // If today is Friday(5), 2nd Tuesday is in 11 days
            // If today is Saturday(6), 2nd Tuesday is in 10 days
            const daysUntil2ndTuesday = 16 - dayOfWeek;

            // Block from today until 2nd Tuesday (inclusive)
            for (let i = 0; i <= daysUntil2ndTuesday; i++) {
                const blockedDate = new Date(today);
                blockedDate.setDate(today.getDate() + i);
                blockedDatesArray.push(blockedDate.getTime());
            }
        }

        setBlockedDates(blockedDatesArray);
        setMinDate(today);

        // Find first available date
        let nextAvailableDate = new Date(today);
        while (blockedDatesArray.includes(nextAvailableDate.getTime())) {
            nextAvailableDate.setDate(nextAvailableDate.getDate() + 1);
        }
        setOpenToDate(nextAvailableDate);
    }, []);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        setValue("Weddingdate", date, { shouldValidate: true }); // Sync     with react-hook-form
    };



    const isAllowedDate = useCallback(
        (date) => !blockedDates.includes(date.getTime()),
        [blockedDates]
    );


    useEffect(() => {
        if (initialValues?.dropShipping?.name) {
            setValue("name", initialValues.dropShipping.name);
        }
    }, [initialValues, setValue]);
    return (
        <Container>
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title page-title">{location.pathname == "/add-wedding-order" ? "Add" : "Update"} Weddings Events {(ticket && location.pathname != "/add-order") && `#${ticket}`}</h3>
                                    </div>
                                </div>
                            </div>

                            <div className="card card-full">
                                <div className="card-inner">
                                    <div className="stepperLeft">
                                        <div className="row">
                                            <div className="col-md-4 brIght">
                                                <section className="section1">
                                                    <header>
                                                        <div className="bead current"><span>1</span></div> {location.pathname == "/add-wedding-order" ? "Add" : "Update"}  Groom Detail
                                                    </header>
                                                </section>
                                                <section className="section2">
                                                    <header>
                                                        <div className="bead"><span>2</span></div>{location.pathname == "/add-wedding-order" ? "Add" : "Update"}  Bride Detail
                                                    </header>
                                                </section>
                                                <section className="section2">
                                                    <header>
                                                        <div className="bead"><span>3</span></div>{location.pathname == "/add-wedding-order" ? "Add" : "Update"} Style Detail
                                                    </header>
                                                </section>
                                                <section>
                                                    <header>
                                                        <div className="bead"><span>4</span></div> {location.pathname == "/add-wedding-order" ? "Add" : "Update"} Description
                                                    </header>
                                                </section>
                                            </div>

                                            <div className="col-md-8">
                                                <h4>{location.pathname == "/add-wedding-order" ? "Add" : "Update"} Groom Detail</h4>
                                                <form onSubmit={handleSubmit(onSubmit)}>
                                                    <div className="inputCardBox mt-4">
                                                        <div className="row">
                                                            {/* <div className="col-md-6 mb-3">
                                                            <label>Event Date <span className="text-red-500">*</span></label>
                                                            <input
                                                                type="date"
                                                                placeholder="Enter event date"
                                                                min={minDate} // Should be current date + 10 days
                                                                {...register("Weddingdate", { required: "Event date is required" })}
                                                            />
                                                            {errors.Weddingdate && <p className='red'>{errors.Weddingdate.message}</p>}
                                                        </div> */}
                                                            {/* <div className="col-md-6 mb-3">
                                                            <label>Event Date <span className="text-red-500">*</span></label>
                                                            <div className="date-picker-container">
                                                                <Controller
                                                                    name="Weddingdate"
                                                                    control={mainControl}
                                                                    rules={{ required: "Event date is required" }}
                                                                    render={({ field }) => (

                                                                        <DatePicker
                                                                            selected={selectedDate}
                                                                            // onChange={handleDateChange}
                                                                            onChange={(date) => {
                                                                                field.onChange(date);
                                                                                handleDateChange(date);
                                                                            }}
                                                                            minDate={minDate}
                                                                            openToDate={openToDate} // ✅ Now properly defined

                                                                            dateFormat="MM/dd/yyyy"
                                                                            placeholderText="MM/DD/YYYY"
                                                                            className="form-control"
                                                                            wrapperClassName="w-100"
                                                                            required
                                                                            filterDate={isAllowedDate} // 🔹 Disable Thu-Sat

                                                                        // {...register("Weddingdate", { required: "Event date is required" })}
                                                                        />)} /> <FaCalendarAlt className="calendar-icon" /> </div>
                                                            {errors.Weddingdate && <p className='text-red-500'>{errors.Weddingdate.message}</p>}
                                                        </div> */}
                                                            <div className="col-md-6 mb-3">
                                                                <label>Wedding Date <span className="text-red-500">*</span></label>
                                                                <div className="date-picker-container">
                                                                    <Controller
                                                                        name="Weddingdate"
                                                                        control={mainControl}
                                                                        defaultValue={initialValues.Weddingdate} // Add this line
                                                                        rules={{ required: "Event date is required" }}
                                                                        render={({ field }) => (
                                                                            <DatePicker
                                                                                selected={field.value} // Use field.value instead of selectedDate
                                                                                onChange={(date) => {
                                                                                    field.onChange(date);
                                                                                    handleDateChange(date);
                                                                                }}
                                                                                minDate={minDate}
                                                                                dateFormat="MM/dd/yyyy"
                                                                                placeholderText="MM/DD/YYYY"
                                                                                className="form-control"
                                                                                wrapperClassName="w-100"
                                                                                required
                                                                                filterDate={isAllowedDate}
                                                                            />
                                                                        )}
                                                                    />
                                                                    <FaCalendarAlt className="calendar-icon" />
                                                                </div>
                                                                {errors.Weddingdate && <p className='text-red-500'>{errors.Weddingdate.message}</p>}
                                                            </div>
                                                            {/* <div className="col-md-6 mb-3">
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <label>Order Type <span className="text-red-500">*</span></label>
                                                                        <Controller
                                                                            name="order_type"
                                                                            control={mainControl}
                                                                            defaultValue={initialValues?.order_type}
                                                                            rules={{ required: "Order type is required" }}
                                                                            render={({ field, fieldState: { error } }) => (
                                                                                <div>
                                                                                    <select {...field} className={error ? 'is-invalid' : ''}>
                                                                                        <option value="">Select Order</option>
                                                                                        <option value="Single Order">Single Order</option>
                                                                                        <option value="Prom Order">Prom Order</option>
                                                                                        <option value="Funeral Order">Funeral Order</option>
                                                                                    </select>
                                                                                    {error && <p className="text-red-500">{error.message}</p>}
                                                                                </div>
                                                                            )}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        {selectedOrderType === 'Prom Order' && (
                                                                            <div className="">
                                                                                <label>
                                                                                    School Name <span className="text-red-500"></span>
                                                                                </label>
                                                                                <input
                                                                                    type="text"
                                                                                    placeholder="Enter school name"

                                                                                    {...register("school", {
                                                                                        // required: "School name is required for Prom Orders"
                                                                                    })}
                                                                                // className={`form-control ${errors.school ? 'is-invalid' : ''}`}
                                                                                />
                                                                                {errors.school && <p className="text-red-500">{errors.school.message}</p>}
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                </div>
                                                            </div> */}
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>First Name <span className="text-red-500">*</span></label>
                                                                <input type="text" placeholder="Enter first name" {...register("Firstname", { required: "First name is required" })} />
                                                                {errors.Firstname && <p className='red'>{errors.Firstname.message}</p>}
                                                            </div>
                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>Last Name <span className="text-red-500">*</span></label>
                                                                <input type="text" placeholder="Enter last name" {...register("Lastname", { required: "Last name is required" })} />
                                                                {errors.Lastname && <p className='red'>{errors.Lastname.message}</p>}
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label>Address <span className="text-red-500"></span></label>
                                                                <input type="text" placeholder="Enter address" {...register("Address")} />
                                                                {errors.Address && <p className='red'>{errors.Address.message}</p>}
                                                            </div>
                                                            <div className="col-md-6 mb-3 stateSelect">
                                                                <label>State <span className="text-red-500"></span></label>
                                                                <Controller
                                                                    name="State"
                                                                    control={mainControl}
                                                                    // rules={{ required: "State is required" }}
                                                                    render={({ field, fieldState: { error } }) => (
                                                                        <div>
                                                                            <Select
                                                                                {...field}
                                                                                options={getState.map(item => ({
                                                                                    value: item.name,
                                                                                    label: item.name
                                                                                }))}
                                                                                placeholder="Select state"
                                                                                isClearable
                                                                                onChange={(selectedOption) => {
                                                                                    field.onChange(selectedOption ? selectedOption.value : '');
                                                                                }}
                                                                                value={getState.map(item => ({
                                                                                    value: item.name,
                                                                                    label: item.name
                                                                                })).find(option => option.value === field.value) || null}
                                                                                className={error ? 'is-invalid' : ''}
                                                                            />
                                                                            {error && <p className="red">{error.message}</p>}
                                                                        </div>
                                                                    )}
                                                                />
                                                            </div>

                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>City <span className="text-red-500"></span></label>
                                                                <input type="text" placeholder="Enter city" {...register("City")} />
                                                                {errors.City && <p className='red'>{errors.City.message}</p>}
                                                            </div>
                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>Zip Code <span className="text-red-500"></span></label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter zip code"
                                                                    {...register("ZipCode", {
                                                                        // required: "Zip code is required",
                                                                        pattern: {
                                                                            value: /^\d+$/,
                                                                            message: "Zip code must be a number"
                                                                        }
                                                                    })}
                                                                    onInput={(e) => {
                                                                        e.target.value = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                                                                    }}
                                                                />
                                                                {errors.ZipCode && <p className='red'>{errors.ZipCode.message}</p>}
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label>Phone Number <span className="text-red-500"></span></label>
                                                                <input
                                                                    type="text"
                                                                    className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 
  ${errors.PhoneNumber ? 'border-red-500' : 'border-gray-300'}`}
                                                                    placeholder="(XXX) XXX-XXXX"
                                                                    maxLength="14"
                                                                    defaultValue={initialValues.PhoneNumber} // Add this
                                                                    {...register('PhoneNumber', {
                                                                        onChange: handleChange,
                                                                        pattern: {
                                                                            value: /^\(\d{3}\) \d{3}-\d{4}$/,
                                                                            message: "Please enter a valid phone number"
                                                                        }
                                                                    })}
                                                                />
                                                                {errors.PhoneNumber && (
                                                                    <p className="text-red-500 text-sm">{errors.PhoneNumber.message}</p>
                                                                )}
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label>Email Address <span className="text-red-500"></span></label>
                                                                <input type="text" placeholder="Enter email" {...register("EmailAddress", {
                                                                    // required: "Email address is required",
                                                                    pattern: {
                                                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                                        message: "Please enter a valid email address"
                                                                    }
                                                                })} />
                                                                {errors.EmailAddress && <p className='red'>{errors.EmailAddress.message}</p>}
                                                            </div>

                                                            <div className="row mt-3 mpadd ">
                                                                <div className="col-md-5 mb-2 mpadd">
                                                                    <div className="custom-control custom-control-sm custom-switch">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="custom-control-input"
                                                                            id="customSwitch7"
                                                                            checked={isChecked}
                                                                            onChange={handleCheckboxChange}
                                                                        />
                                                                        <label className="custom-control-label" htmlFor="customSwitch7">
                                                                            Alternate Pickup Location
                                                                        </label>
                                                                    </div>
                                                                    {
                                                                        isChecked && <>
                                                                            <div className="mt-2">
                                                                                <label>Affiliated Store</label>
                                                                                <select  {...register("Affiliated_store", {
                                                                                    required: isChecked ? "Please select an affiliated store" : false
                                                                                })} onChange={handleSelectChange} className={errors.Affiliated_store ? "is-invalid" : ""}>
                                                                                    <option value="">Select a Company</option>
                                                                                    {order.length > 0 ? (
                                                                                        order.map((data) => (
                                                                                            <option key={data.id} value={data.companyName}>
                                                                                                {data.companyName}
                                                                                            </option>
                                                                                        ))
                                                                                    ) : (
                                                                                        <option disabled>No affiliated stores found</option>
                                                                                    )}
                                                                                </select>
                                                                                {errors.Affiliated_store && (
                                                                                    <p className="text-red-500">{errors.Affiliated_store.message}</p>
                                                                                )}
                                                                                {/* Show Address Below Dropdown */}
                                                                                {selectedAddress && (
                                                                                    <div style={{ marginTop: '10px', padding: '10px', border: '1px solid #ddd' }}>
                                                                                        <strong>Address:</strong> {selectedAddress.split("- Account:")[0]} <br />
                                                                                        <strong style={{ color: 'BLACK' }}>Account: {selectedAddress.split("- Account:")[1]}</strong>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                            {
                                                                                address != '' && <div className="col-md-12 mt-3 mpadd">
                                                                                    <div className="affiliateBox">
                                                                                        <p className="mb-1 text-dark"> Group : {address?.affiliatedStore} <small>#{address?.account}</small></p>
                                                                                        <ul>
                                                                                            <li><em className="icon ni ni-user-alt"></em> {address?.companyName}</li>
                                                                                            <li><em className="icon ni ni-map-pin"></em> {address?.addresses[0]?.billingAddress} {address?.addresses[0]?.billingAddressLine2} {address?.addresses[0]?.billingCity} {address?.addresses[0]?.billingState} {address?.addresses[0]?.billingZip}</li>
                                                                                        </ul>
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </>
                                                                    }
                                                                </div>
                                                                <div className="col-md-5 mb-2 mpadd">
                                                                    <div className="custom-control custom-control-sm custom-switch">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="custom-control-input"
                                                                            id="customSwitch8"
                                                                            checked={isDropShipping}
                                                                            onChange={handleDropShippingToggle}
                                                                        />
                                                                        <label
                                                                            className="custom-control-label"
                                                                            htmlFor="customSwitch8"
                                                                            {...(isDropShipping == false ? {
                                                                                "data-bs-toggle": "modal",
                                                                                "data-bs-target": "#dropShipping"
                                                                            } : {})}
                                                                        >
                                                                            Drop Shipping
                                                                        </label>
                                                                    </div>
                                                                    {isDropShipping && dropShippingData && (
                                                                        <div className="dropShippingField mt-2 p-2 border rounded d-flex align-items-center justify-content-between">
                                                                            <span className="text-truncate" style={{ maxWidth: "80%" }}>
                                                                                {dropShippingData.addressLine1}, {dropShippingData.city}, {dropShippingData.state}
                                                                            </span>

                                                                            <button
                                                                                type="button"  // ✅ Add this to prevent form submission
                                                                                className="btn btn-link text-primary"
                                                                                // onClick={() => alert("ok working")}
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#dropShipping"
                                                                            >
                                                                                ✏️ Edit
                                                                            </button>

                                                                        </div>
                                                                    )}

                                                                </div>
                                                            </div>
                                                            <br></br>
                                                            <div className="col-md-12 mt-3">
                                                                <button type="submit" className="addBtnCustomer">Continue</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >



            <div className="modal fade" tabIndex="-1" id="dropShipping">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Drop Shipping</h5>
                            <a href="#" className="close" data-bs-dismiss="modal" aria-label="Close">
                                <em className="icon ni ni-cross-c"></em>
                            </a>
                        </div>
                        <form onSubmit={(e) => {
                            e.preventDefault(); // This prevents the default form submission
                            handleSubmitShipping(onDropShippingSubmit)();
                        }}>
                            <div className="modal-body inputCardBox">
                                <div className="row">
                                    <div className="col-md-12 mb-2">
                                        <h6 className="instructionHeading">
                                            Drop shipment are charged all shipping costs, plus a $6 fee per address per week.
                                            RS labels are included inside each box unless otherwise requested.
                                        </h6>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label>Name  <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            className={`form-control ${shippingErrors.name ? 'is-invalid' : ''}`}
                                            placeholder="Enter Name"
                                            defaultValue={initialValues?.dropShipping?.name || ""}
                                            {...registerShipping("name", {
                                                required: "Name is required",
                                                value: initialValues?.dropShipping?.name || "" // Add this line
                                            })}
                                        />
                                        {shippingErrors.name && <p className="red">{shippingErrors.name.message}</p>}
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label>Address line 1<span className="text-danger">*</span> </label>
                                        <input
                                            type="text"
                                            className={`form-control ${shippingErrors.addressLine1 ? 'is-invalid' : ''}`}
                                            placeholder="Enter Address line 1"
                                            {...registerShipping("addressLine1", { required: "Address is required" })}
                                        />
                                        {shippingErrors.addressLine1 && <p className="red">{shippingErrors.addressLine1.message}</p>}
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label>Address line 2</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Address line 2"
                                            {...registerShipping("addressLine2")}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>City </label>
                                        <input
                                            type="text"
                                            className={`form-control ${shippingErrors.city ? 'is-invalid' : ''}`}
                                            placeholder="Enter City"
                                            {...registerShipping("city")}
                                        />
                                        {shippingErrors.city && <p className="red">{shippingErrors.city.message}</p>}
                                    </div>
                                    <div className="col-md-6 mb-3 stateSelect">
                                        <label>State </label>
                                        <Controller
                                            name="state"
                                            control={control}
                                            // rules={{ required: "State is required" }}
                                            render={({ field, fieldState: { error } }) => (
                                                <div>
                                                    <Select
                                                        {...field}
                                                        options={getState.map(item => ({
                                                            value: item.name,
                                                            label: item.name
                                                        }))}
                                                        placeholder="Select state"
                                                        onChange={(selectedOption) => {
                                                            field.onChange(selectedOption ? selectedOption.value : '');
                                                        }}
                                                        value={getState.map(item => ({
                                                            value: item.name,
                                                            label: item.name
                                                        })).find(option => option.value === field.value) || null}
                                                        className={error ? 'is-invalid' : ''}
                                                    />
                                                    {error && <p className="red">{error.message}</p>}
                                                </div>
                                            )}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>Zip Code </label>
                                        <input
                                            type="text"
                                            className={`form-control ${shippingErrors.zipCode ? 'is-invalid' : ''}`}
                                            placeholder="Enter Zip Code"
                                            {...registerShipping("zipCode", {
                                                // required: "Zip code is required",
                                                pattern: {
                                                    value: /^\d+$/,
                                                    message: "Please enter a valid zip code"
                                                }
                                            })}
                                            onInput={(e) => {
                                                e.target.value = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                                            }}
                                        />
                                        {shippingErrors.zipCode && <p className="red">{shippingErrors.zipCode.message}</p>}
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>Phone <span className="text-danger">*</span> </label>
                                        <input
                                            type="text"
                                            className={`form-control ${shippingErrors.phone ? 'is-invalid' : ''}`}
                                            placeholder="(XXX) XXX-XXXX"
                                            maxLength="14"
                                            {...registerShipping('phone', {
                                                required: "Phone number is required",
                                                onChange: handleChangemo,
                                                pattern: {
                                                    value: /^\(\d{3}\) \d{3}-\d{4}$/,
                                                    message: "Please enter a valid phone number"
                                                }
                                            })}
                                        />
                                        {shippingErrors.phone && <p className="red">{shippingErrors.phone.message}</p>}
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-4 mb-3">
                                        <button type="submit" className="addBtnCustomer">Add Ship</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Container >
    )
}

export default WeddingEvent
